import React, { useEffect, useState, useRef } from 'react';
import styled from 'styled-components';
import api from '@/apis/pc/conversation/conversation';
import userApi from '@/apis/pc/user/user';
import { useSelector } from 'react-redux';
import HeadImg from '@/components/common/head-img/headImg';
import { message, Input, Spin } from 'antd';
import { useUpdateEffect } from '@/hooks/useUpdateEffect';
import { getParameterByName, debounce } from '@/utils/utils';
import InfiniteScroll from 'react-infinite-scroll-component';
const { Search } = Input;

const ContactWrapper = styled.div`
  width: 100%;
`;
const ListLine = styled.div`
  width: 100%;
  margin-bottom: 8px;
  &.active-line {
    .contact-list-line {
      background: #fff2ea !important;
    }
    .contact-list-name {
      padding: 0 4px;
      line-height: 27px;
      color: #595959;
      overflow: hidden;
    }

    .contact-list-line-group {
      background: #fff2ea !important;
    }
    .group-right {
      color: #595959;
      overflow: hidden;
    }
  }
  .contact-list-img {
    display: inline-block;
  }
  .contact-list-line {
    font-size: 12px;
    display: inline-block;
    height: 26px;
    cursor: pointer;
    width: 268px;
    vertical-align: bottom;
    .contact-list-info {
      display: inline-block;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      vertical-align: middle;
      width: 212px;
      height: 26px;
      margin-top: -1px;
    }
    .contact-list-name {
      padding: 0 4px;
      line-height: 27px;
      color: #595959;
      overflow: hidden;
    }
    .contact-list-companyInfo {
      color: #bfbfbf;
    }
    .label-status {
      display: inline-block;
    }
  }

  .contact-list-line-group {
    display: flex;
    margin-bottom: 8px;

    img {
      width: 32px;
      height: 32px;
    }

    .group-right {
      display: flex;
      flex-direction: column;
      font-size: 12px;
      padding-left: 8px;

      span {
        display: inline-block;
        height: 16px;
        line-height: 16px;
      }

      .contact-right-name {
        color: #595959;
      }

      .group-right-name {
        color: #bfbfbf;
      }
    }
  }
`;
const DeleteLabel = styled.span`
  display: inline-block;
  background: rgba(151, 109, 208, 0.1);
  color: #976dd0;
  font-size: 12px;
  margin-left: 8px;
  padding: 2px 4px;
  margin-top: 2px;
`;
const OutLabel = styled.span`
  display: inline-block;
  background: #fef2f7;
  color: #f77fb3;
  font-size: 12px;
  margin-left: 8px;
  padding: 2px 4px;
  margin-top: 2px;
`;
const SearchDiv = styled(Search)`
  width: 288px;
  height: 24px;
  margin-bottom: 8px;

  .ant-input-wrapper {
    input {
      height: 24px;
    }

    button {
      height: 24px;
    }
  }
`;

const ContactList = (props) => {
  const { loading } = props
  const { handleChange, session, searchCondition, userList = [] } = props;
  const [showSelect, setShowSelect] = useState(false); // 是否员工选择框
  const currentUser = useSelector((state) => state.userInfo.userInfo); // 当前登录用户信息
  const [operateData, setOperateData] = useState({}); // 当前查看的用户
  const selectref = useRef(null);
  const [clieckType, setClieckType] = useState('1');
  const [searchNameParam, setSearchNameParam] = useState('');
  const [page, setPage] = useState(1)

  const ContactState = (props) => {
    const { type } = props;
    switch (type) {
      case 1:
        return null;
      case 2:
        return <DeleteLabel>已删除</DeleteLabel>;
      case 3:
        return <OutLabel>未允许</OutLabel>;
      default:
        return null;
    }
  };

  // 查询当前员工是否开通了消息存档
  const getCurrentUserEnable = () => {
    api
      .getCurrentUserEnable({ uid: currentUser.uid, oid: currentUser.oid })
      .then((res) => {
        const { code, data } = res;
        if (code === 0) {
          let type = getParameterByName('deviceType') === 'iframe' ? 2 : 1;
          let crmCustomerId = getParameterByName('id');

          userApi
            .getCovUsers({
              name: '',
              pageNum: 1,
              pageSize: 50,
              type,
              crmCustomerId,
            })
            .then((response) => {
              if (response.code === 0) {
                if (response.data.length > 0) {
                  if (
                    data.sessionType &&
                    response.data.find((item) => item.uid === data.uid)
                  ) {
                    // 当前操作者开通了企微助手消息存档
                    setOperateData(data);
                  } else {
                    // 默认选择列表中的第一条
                    setOperateData(response.data[0]);
                  }
                }
              } else {
                message.warning(response.message);
              }
            });
        }
      });
  };
  // useEffect(() => {
  //   if (currentUser.uid) {
  //     getCurrentUserEnable();
  //   }
  // }, [currentUser]);

  useEffect(() => {
    if (operateData.uid) {
      props.handleSetUid(operateData.uid);
    }
  }, [operateData, searchCondition]);

  useEffect(() => {
    if (showSelect) {
      selectref?.current?.querySelector('input').focus();
    }
  }, [showSelect]);

  useUpdateEffect(() => {
    setShowSelect(props.selectFlag);
  }, [props.selectFlag]);

  const onSearchInput = (val) => {
    setSearchNameParam(val);
  };

  const getList = () => {
    if (!searchNameParam) {
      return props?.userList?.slice(0, 20 * page);
    } else {
      return props?.userList?.filter((item) =>
        item.name?.includes(searchNameParam?.trim())
      );
    }
  };

  const handleInput = debounce(onSearchInput, 450);
  const data = getList()
  const getHasMore = () => {
    if(searchNameParam) {
      return false
    }
    else {
      return true
    }
  }

  return (
    <ContactWrapper>
      <Spin spinning={loading && data?.length === 0}>
        {clieckType === '4' ? null : (
          <SearchDiv
            style={{ margin: '16px' }}
            placeholder={'搜索好友昵称/备注'}
            autoComplete={'false'}
            onSearch={(e) => {
              onSearchInput(e);
            }}
            onChange={(e) => {
              handleInput(e.target.value);
            }}
          />
        )}

        {/*外部好友*/}
        {clieckType === '1' ? (
          <InfiniteScroll
          hasMore={getHasMore}
          dataLength={data?.length}
          height='calc(100vh - 120px)'
          style={{ border: 'none', padding: '0 16px' }}
          next={() => {
            setPage(page + 1)
          }}
          >
            {data?.map((item) => {
              return (
                <ListLine
                  key={item.uid}
                  onClick={() => handleChange({ setType: 'session', ...item })}
                  className={
                    session.uid === item.uid ? 'active-line' : 'list-line'
                  }
                >
                  <div className={'contact-list-img'}>
                    <HeadImg
                      url={item.userImg ? item.userImg : item.extendUserImg}
                      name={
                        item.extendUserRemark
                          ? item.extendUserRemark
                          : item.extendUserName
                      }
                      width={24}
                      height={24}
                    />
                  </div>

                  <div className={'contact-list-line'}>
                    <div className={'contact-list-info'}>
                      <span className={'contact-list-name'}>
                        {item.name}
                      </span>
                    </div>
                    <div className={'label-status'}>
                      <ContactState type={item.status} />
                    </div>
                  </div>
                </ListLine>
              );
            })}
          </InfiniteScroll>
        ) : null}
      </Spin>
    </ContactWrapper>
  );
};

export default ContactList;
